<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link class="btn btn-primary" to="/ajouter-inscription">
          <i class="fa fa-plus-circle"></i>
          Ajouter inscription
        </router-link>


      </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher" class="form-control shadow-none text-black"
            placeholder="Rechercher inscription" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>

      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
               <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Numéro Matricule
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Categorie
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Etudiant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Filiere
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Niveau
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Annee
              </th>
             
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0">ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(inscription, index) in inscriptions" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ inscription?.etudiant?.numeroMatricule }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ inscription?.etudiant?.categorieEtudiant }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ inscription?.etudiant?.nom }} {{ inscription?.etudiant?.prenom }}
                <span v-if="inscription?.etudiant?.estTalent" class="badge bg-warning text-dark ms-2">
                  Talent 
                </span>
              </td>
            
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ inscription?.filiere?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ inscription?.niveau?.libelle }} </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ inscription?.annee?.libelle }}
              </td>
             
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">

                    <li class="dropdown-item d-flex align-items-center">
                      <a href="#" data-bs-toggle="modal" data-bs-target="#AddElementModal"
                        @click="openAddParentModal(inscription)">
                        <i class="fa fa-lock lh-2 me-8 position-relative top-1"></i>
                        Ajouter un parent
                      </a>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                        <router-link :to="{ name: 'ViewInscriptionPage', params: { id: inscription.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                        </router-link>
                    </li>
                    
                    <li class="dropdown-item d-flex align-items-center" 
                      @click.prevent="!inscription.etudiant.estTalent && marquerCommeTalent(inscription.etudiant)" 
                      :style="{ cursor: inscription.etudiant.estTalent ? 'not-allowed' : 'pointer' }">
                    
                    <i :class="['fa', 'lh-2', 'me-8', 'position-relative', 'top-1', inscription.etudiant.estTalent ? 'fa-star text-secondary' : 'fa-star text-warning']"></i>
                    
                    {{ inscription.etudiant.estTalent ? 'Déjà marqué comme talent' : ' Marquer comme talent' }}
                  </li>

                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddParentModal :selectedInscription="selectedInscription" />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Swal from "sweetalert2";
import { Inscription } from "@/models/Inscription";
import ApiService from "@/services/ApiService";
import {format_Date, suppression, error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { useRouter } from 'vue-router';
import AddParentModal from './AddParent.vue';

export default defineComponent({
  name: "ListeInscription",
  components: {
    PaginationComponent,
    AddParentModal,
  },
  setup() {

    onMounted(() => {
      getAllInscriptions();
    });

    const inscriptions = ref<Array<Inscription>>([]);
    const inscription = ref<Inscription>();
    const selectedInscription = ref<Inscription | undefined>(undefined);
    const selectedInscriptionId = ref<number>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const router = useRouter();

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllInscriptions(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher() {
      getAllInscriptions(page.value, limit.value, searchTerm.value);
    }


    // END PAGINATE

    function getAllInscriptions(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/inscriptions?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log('valeurs', data);
          inscriptions.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });

    }

    function moddifier(EditInscription: Inscription) {
      inscription.value = EditInscription;
    }

    const openAddParentModal = (inscription: Inscription) => {
      selectedInscription.value = { ...inscription };
      selectedInscriptionId.value = inscription.id;
      console.log('inscription sélectionnée ', selectedInscription.value);
    };


    const deleteInscription = (id: number) => {
      ApiService.delete(`/inscriptions/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });

      for (let i = 0; i < inscriptions.value.length; i++) {
        if (inscriptions.value[i].id === id) {
          inscriptions.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

const marquerCommeTalent = async (etudiant: any) => {
  if (!etudiant?.id) {
    Swal.fire({
      icon: 'error',
      text: 'Identifiant étudiant invalide',
      heightAuto: false
    })
    return
  }

  // Vérifie si déjà talent
  if (etudiant.estTalent) {
    Swal.fire({
      icon: 'info',
      text: `${etudiant.nom} ${etudiant.prenom} est déjà marqué comme talent.`,
      heightAuto: false
    })
    return
  }

  const result = await Swal.fire({
    title: `Voulez-vous vraiment marquer ${etudiant.nom} ${etudiant.prenom} comme talent ?`,
    icon: 'question',
    showCancelButton: true,
    cancelButtonText: 'Annuler',
    confirmButtonText: 'Oui, marquer',
    reverseButtons: false,
    heightAuto: false
  })

  if (!result.isConfirmed) return

  try {
    const { data } = await ApiService.put(`/etudiants/${etudiant.id}/set-talent`, {})

    Swal.fire({
      icon: 'success',
      text: data.message || `L'étudiant ${etudiant.nom} ${etudiant.prenom} est désormais un talent 🎉`,
      toast: true,
      position: 'top-right',
      showConfirmButton: false,
      timer: 4000,
      heightAuto: false
    })

    await getAllInscriptions(page.value, limit.value, searchTerm.value)

  } catch (err: any) {
    console.error('Erreur marquerCommeTalent:', err)
    Swal.fire({
      icon: 'error',
      text: err.response?.data?.message || "Une erreur est survenue.",
      heightAuto: false
    })
  }
}

    return {
      inscriptions,
      checkPermission,
      getAllInscriptions,
      format_Date,
      deleteInscription,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      marquerCommeTalent,
      openAddParentModal,
      handlePaginate,
      rechercher,
      selectedInscription, selectedInscriptionId,
      searchTerm
    };
  },
});
</script>